module.exports = __webpack_public_path__ + "static/img/ceac257.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/lhsx/dhqhLogo.png
// module id = 255
// module chunks = 2